function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.804,
  cy: 88.604,
  rx: 4.318,
  ry: 3.33
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 34.205,
  cy: 83.205,
  rx: 4.318,
  ry: 3.331
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 48.674,
  cy: 77.808,
  rx: 4.318,
  ry: 3.33
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 63.143,
  cy: 72.41,
  rx: 4.317,
  ry: 3.331
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M81.93 66.553c0 1.839-1.933 3.332-4.317 3.332s-4.316-1.493-4.316-3.332c0-1.837 1.932-3.33 4.316-3.33s4.317 1.493 4.317 3.33z"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.804,
  cy: 78.383,
  r: 1.666
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.804,
  cy: 65.69,
  r: 1.666
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.804,
  cy: 52.999,
  r: 1.666
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.804,
  cy: 40.308,
  r: 1.666
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.205,
  cy: 65.69,
  r: 1.666
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.674,
  cy: 65.69,
  r: 1.666
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.205,
  cy: 52.999,
  r: 1.666
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.205,
  cy: 40.308,
  r: 1.666
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.674,
  cy: 52.999,
  r: 1.666
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.674,
  cy: 40.308,
  r: 1.666
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 63.144,
  cy: 52.999,
  r: 1.666
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 63.144,
  cy: 40.308,
  r: 1.666
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 77.613,
  cy: 40.308,
  r: 1.666
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M16.961 17.318v-3.617a2.842 2.842 0 015.685 0v3.617M16.961 17.592a2.842 2.842 0 015.685 0M31.362 17.318v-3.617a2.841 2.841 0 115.684 0v3.617M45.832 17.318v-3.617a2.841 2.841 0 012.842-2.842 2.84 2.84 0 012.842 2.842v3.617M60.301 17.318v-3.617a2.841 2.841 0 115.684 0v3.617M74.77 17.318v-3.617a2.842 2.842 0 015.685 0v3.617M31.362 17.592a2.842 2.842 0 015.685 0M45.832 17.592a2.841 2.841 0 115.684 0M60.301 17.592a2.842 2.842 0 115.685 0M74.77 17.592a2.842 2.842 0 115.685 0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M86.225 21.489V3.624H11.123v17.865H8.406v14.569h2.716v51.626c0 4.749 3.863 8.613 8.612 8.613 4.496 0 8.192-3.464 8.575-7.862a8.572 8.572 0 005.895 2.351c4.496 0 8.193-3.465 8.575-7.863a8.57 8.57 0 005.895 2.351c4.496 0 8.193-3.464 8.575-7.862a8.572 8.572 0 005.895 2.351c4.496 0 8.193-3.465 8.575-7.863a8.57 8.57 0 005.895 2.351c4.749 0 8.612-3.863 8.612-8.612V36.058h2.717V21.489h-2.718zM71.756 6.38h11.713v15.109H71.756V6.38zm-14.469 0H69v15.109H57.287V6.38zm-14.47 0H54.53v15.109H42.817V6.38zm-14.469 0h11.714v15.109H28.348V6.38zm-14.47 0h11.713v15.109H13.878V6.38zm11.714 75.792v5.512a5.864 5.864 0 01-5.857 5.857 5.863 5.863 0 01-5.856-5.857V36.058h11.713v46.114zm14.47-5.513v5.513c0 3.229-2.627 5.857-5.857 5.857s-5.857-2.628-5.857-5.857V36.058h11.714v40.601zm14.469-5.512v5.512c0 3.229-2.628 5.857-5.857 5.857s-5.856-2.628-5.856-5.857V36.058h11.713v35.089zM69 65.636v5.512c0 3.229-2.628 5.857-5.857 5.857s-5.856-2.628-5.856-5.857v-35.09H69v29.578zm14.469 0c0 3.229-2.627 5.856-5.856 5.856s-5.856-2.627-5.856-5.856V36.058H83.47v29.578zm2.83-32.259h-75.25v-9.5h75.25v9.5z"
});

function SvgFlute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 99.254"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

export default SvgFlute;